import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { getAllUsers } from "../../../config/LiveApi";
import DateFilter from "../../../components/common/DateFilter";

function HeaderTableComplaint({
  setParentStartDate,
  setParentEndDate,
  setParentUserId,
  currentPage,
}) {
  const [merchantNames, setMerchantNames] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const MerchantOptions = merchantNames.map((merch) => ({
    value: merch?.id,
    label: merch?.alias ? merch?.alias : merch?.id,
  }));
  const handleMerchChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedMerchant(null);
      setParentUserId(null); // 🔥 clear filter
      return;
    }

    setSelectedMerchant({
      name: selectedOption.label,
      value: selectedOption.value,
    });

    setParentUserId(selectedOption.value); // 🔥 SEND USER ID
  };

  const token = useSelector((store) => store.userReducer.token);
  let role = useSelector((store) => store.userReducer.role);

  useEffect(() => {
    const fetchMerchNames = async () => {
      try {
        if (role === "admin" || role === "subAdmin") return;
        const response = await getAllUsers(token, 1);
        const filteredData = await response.data.filter((merchant) => {
          return merchant.role === "admin";
        });
        setMerchantNames(filteredData);
        setSelectedMerchant(null);
      } catch (error) {
        console.error("Error fetching merchants:", error);
      }
    };

    fetchMerchNames();
  }, [token]);

  const handleDateChange = (startDate, endDate) => {
    setParentStartDate(new Date(startDate));
    setParentEndDate(new Date(endDate));
  };

  return (
    <>
      <div className="recon-header complaint-header">
        <div className="complaint-header-left">
          <h2 className="area-top-management">Complaints Table</h2>

          {role !== "admin" && role !== "subAdmin" && (
            <ReactSelect
              className="merchant-filter"
              classNamePrefix="react-select"
              value={
                selectedMerchant
                  ? {
                      value: selectedMerchant.value,
                      label: selectedMerchant.name,
                    }
                  : null
              }
              options={MerchantOptions}
              onChange={handleMerchChange}
              placeholder="Select Merchant"
              isClearable
            />
          )}
        </div>
      </div>
      <DateFilter onDateChange={handleDateChange} />
    </>
  );
}

export default HeaderTableComplaint;
